module.exports = __webpack_public_path__ + "static/06_home_screen_v4.a4c06a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/06_home_screen_v4.jpg
// module id = 515
// module chunks = 111663361672460